import React from 'react';
import './Sidebar.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SidebarPropTypes } from '../utils/propTypes';

const Sidebar = ({ isOpen, toggleSidebar, isMobileView }) => {
    const navigate = useNavigate();
    const authCtx = useAuth();
    const location = useLocation();
    const currentPath = location.pathname;

    const isCareTeam = authCtx.user.is_care_team;

    const handleLogout = () => {
        authCtx.onLogOut();
    }

    const handleNavigate = () => {
        navigate(`/therapist`)
    }

    return (
        <>
            {
                !isMobileView ? (
                    <aside className={`sidebar desktop-view ${isOpen ? 'open' : 'closed'}`}>
                        <div className="profile-info">
                            <div className='profile-image-container'>
                                <img className='rounded-circle profile-image' src={authCtx.user.image} alt='Not Found' width={'120px'}></img>
                            </div>
                            <h5 className='title-font profile-name mt-2'>{authCtx.user.first_name} {authCtx.user.last_name}</h5>
                            {!isCareTeam && (
                                <button className="profile-link bg-transparent border-0 p-0 m-0" onClick={() => { handleNavigate() }}>View Profile</button>
                            )}
                        </div>
                        <nav className='nav-list-container'>
                            <ul className='menu-list custom-font' style={{ listStyleType: 'none', padding: '0px' }}>
                                <li className={currentPath === '/planner' ? 'active-menu-item menu-item' : 'menu-item'}>
                                    <NavLink to="/planner">
                                        <span className='material-icons'>calendar_month</span>
                                        <span className='menu-item-label'>Planner</span>
                                    </NavLink>
                                </li>

                                {!isCareTeam && (
                                    <li className={currentPath === '/clients' ? 'active-menu-item menu-item' : 'menu-item'}>
                                        <NavLink to="/clients">
                                            <i className="bi bi-person menu-item-icon"></i>
                                            <span className='menu-item-label'>My Clients</span>
                                        </NavLink>
                                    </li>
                                )}
                            </ul>
                        </nav>
                    </aside>
                ) : (
                    <div className="container-fluid-mobile-view navbar navbar-dark bg-dark">
                        <div className={`custom-offcanvas offcanvas offcanvas-end ${isOpen ? 'show' : 'hide'}`} tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                            <div className="offcanvas-header">
                                <button type="button" onClick={() => { toggleSidebar() }} className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                            </div>
                            <div className="offcanvas-body">
                                <div className="profile-info">
                                    <div className='profile-image-container'>
                                        <img className='rounded-circle profile-image' src={authCtx.user.image} alt='Not Found' width={'120px'}></img>
                                    </div>
                                    <h5>{authCtx.user.first_name} {authCtx.user.last_name}</h5>
                                    {!isCareTeam && (
                                        <button className="profile-link bg-transparent border-0 p-0 m-0" onClick={() => { handleNavigate() }}>View Profile</button>
                                    )}
                                </div>
                                <nav className='nav-list-container'>
                                    <ul className='menu-list custom-font' style={{ listStyleType: 'none', padding: '0px' }}>
                                        <li className={currentPath === '/planner' ? 'active-menu-item menu-item' : 'menu-item'}>
                                            <NavLink to="/planner">
                                                <span className='material-icons'>calendar_month</span>
                                                <span className='menu-item-label'>Planner</span>
                                            </NavLink>
                                        </li>
                                        {!isCareTeam && (
                                            <li className={currentPath === '/clients' ? 'active-menu-item menu-item' : 'menu-item'}>
                                                <NavLink to="/clients">
                                                    <i className="bi bi-person menu-item-icon"></i>
                                                    <span className='menu-item-label'>My Clients</span>
                                                </NavLink>
                                            </li>
                                        )}
                                        <li className='menu-item'>
                                            <NavLink onClick={handleLogout} className='logout-btn'>
                                                <span className='material-icons'>power_settings_new</span>
                                                <span className='menu-item-label'>Logout</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

Sidebar.propTypes = SidebarPropTypes;

export default Sidebar;
